import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class LoadingState {
    private isLoading: boolean = false;
    private stateChanged$ = new Subject<boolean>();
    public stateChanged = this.stateChanged$.asObservable();

    public start() {
        this.isLoading = true;
        this.notifyStateChanged();
    }

    public stop(): void {
        this.isLoading = false;
        this.notifyStateChanged();
    }

    private notifyStateChanged(): void {
        this.stateChanged$.next(this.isLoading);
    }
}
